/**
 * Talala API Gateway
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MarketplaceAssetModelV2 } from './marketplaceAssetModelV2';

export interface MarketOfferV2 {
  id: string;
  price: string;
  asset: MarketplaceAssetModelV2;
}
